import React from 'react';

import { Box, Paper, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2)
  },
  banner: {
    width: '100%',
    height: 65,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    maxWidth: 900,
    padding: theme.spacing(1),
    backgroundColor: '#ffe4e9',
    color: '#a7002d',
    textAlign: 'center',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    border: '1px solid #f8b7c3'
  },
  icon: {
    fontSize: 30,
    color: '#d81b60',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  refreshButton: {
    width: 31,
    height: 31,
    backgroundColor: '#d03673',
    color: '#ffffff',
    borderRadius: 8
  }
}));

const TranscriptionsAndSolutionsErrorMessageBox = ({ showRetry, onRetry }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Paper className={classes.banner} elevation={3}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography>
          Something went wrong while extracting questions and answers. Please
          manually transcribe the work.
        </Typography>
        {showRetry && (
          <IconButton className={classes.refreshButton} onClick={onRetry}>
            {' '}
            <AutorenewIcon />
          </IconButton>
        )}
      </Paper>
    </Box>
  );
};

export default TranscriptionsAndSolutionsErrorMessageBox;
